import React from 'react';
import SelectSearch, { createFilter } from 'react-select';

class LocationsFilter extends React.Component {
  constructor(props) {
    super(props);

    this.MIN_CHARS = 2;
    this.FILTER_OPTIONS = {
      ignoreCase: true,
      ignoreAccents: true,
      trim: true,
      matchFrom: 'start' // start|any, see https://react-select.com/advanced#custom-filter-logic
    };

    // populate options
    let options = [];
    Object.keys(this.props.appData.cache.locationsById).forEach((id) => {
      const location = this.props.appData.cache.locationsById[id];

      let locationDescr;
      switch (location.type) {
        case 'region':
          locationDescr = 'regione';
          break;
        case 'province':
          locationDescr = 'provincia di';
          break;
        case 'city':
          locationDescr = 'comune di';
          break;
      }
      options.push({
        label: location.name + ' (' + locationDescr + ')',
        value: location.id
      });
    });
    options.sort((a,b) => {
      if (a.label < b.label) return -1;
      if (a.label > b.label) return 1;

      return 0;
    });
    this.options = options;

    this.state = {
      searchEnabled: false
    };

    this.handleTyping = this.handleTyping.bind(this);
    this.handleLocationChange = this.handleLocationChange.bind(this);
  }

  handleTyping(typed) {
    let searchEnabled;

    if (typed.length < this.MIN_CHARS) {
      searchEnabled = false;
    } else if (typed.length >= this.MIN_CHARS) {
      searchEnabled = true;
    }

    if (searchEnabled != this.state.searchEnabled) {
      this.setState({
        searchEnabled
      });
    }
  }

  handleLocationChange(location) {
    const id = location.value;

    if (this.props.onChange) {
      this.props.onChange(id);
    }
  }

  render() {
    let currLocation = null;
    if (this.props.value) {
      for (let i=0; i<this.options.length; i++) {
        if (this.options[i].value == this.props.value) {
          currLocation = this.options[i];
        }
      }
    }

    return (
      <div>
        <SelectSearch
          options={this.state.searchEnabled ? this.options : []}
          filterOption={createFilter(this.FILTER_OPTIONS)}

          isSearchable={true}
          isClearable={false}

          placeholder="Cerca regione/provincia/citta"
          value={currLocation}

          onInputChange={this.handleTyping}
          onChange={this.handleLocationChange}
        />
      </div>
    );
  }
}

export default LocationsFilter;


// WEBPACK FOOTER //
// ./src/components/shared/filters/LocationsFilter.js